import { Button, getKeyValue } from "@nextui-org/react";
import { Key, useCallback, useState } from "react";
import EditPlayerList from "./editplayerlist";
import ResetPlayerPasswordView from "./resetpassword";
// import ReferralView from "./referrelview";
import {
  ActiveIcon,
  EditIcon,
  InActiveIcon,
  // ReferralIcon,
  SuspendIcon,
} from "@/assets/icons/admin";
import CustomDropdown from "../../customdropdown";
import { useGetAllPlayers } from "@/services/admin.service";
import { PlayerUser } from "@/types";
import { format } from "date-fns";
import Datatable from "@/components/tables/datatable";

const statuses = [
  { label: "All", value: "" },
  { label: "Active", value: "ACTIVE" },
  { label: "Inactive", value: "IN_ACTIVE" },
  { label: "Suspend", value: "SUSPEND" },
];

const fields = [
  { label: "Username", value: "userName" },
  { label: "Email", value: "email" },
  { label: "Last IP", value: "lastIP" },
];

const columns = [
  {
    key: "no",
    label: "No",
  },
  {
    key: "userName",
    label: "Username",
    sortable: true,
  },
  {
    key: "fullName",
    label: "Fullname",
    sortable: true,
  },
  {
    key: "status",
    label: "Status",
    sortable: true,
  },
  {
    key: "tierId",
    label: "Tier",
    sortable: true,
  },
  {
    key: "createdAt",
    label: "Join Date",
    sortable: true,
  },
  {
    key: "lastLogin",
    label: "Last Login",
    sortable: true,
  },
  {
    key: "email",
    label: "Email",
    sortable: true,
  },
  {
    key: "lastip",
    label: "Last IP",
  },
  {
    key: "action",
    label: "Action",
  },
];

const PlayerList = () => {
  const [selectedStatus, setSelectedStatus] = useState<string | null>();
  const [isEditingPlayer, setIsEditingPlayer] = useState(false);
  const [editItemData, setEditItemData] = useState<PlayerUser>();
  const [isResettingPw, setIsResettingPw] = useState(false);

  const query = useGetAllPlayers;

  const handleEditClick = (itemId: any) => {
    setIsEditingPlayer(true);
    setEditItemData(itemId);
  };

  const handleCancelEdit = () => {
    setIsEditingPlayer(false);
    setEditItemData("" as any);
  };

  const handleResetPasswordCancel = () => {
    setIsResettingPw(false);
  };

  // const handleViewReferralClick = () => {
  //   setIsViewingReferrals(true);
  // };

  // const handleViewReferralCancel = () => {
  //   setIsViewingReferrals(false);
  // };

  const capitalize = (str: any) => {
    if (!str) return "";
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
  };

  const renderCell = useCallback((data: any[], item: any, columnKey: Key) => {
    switch (columnKey) {
      case "status":
        return (
          <div className="flex items-center">
            {item.status === "ACTIVE" ? (
              <span>
                <ActiveIcon />
              </span>
            ) : item.status === "IN_ACTIVE" ? (
              <span>
                <InActiveIcon />
              </span>
            ) : (
              <span>
                <SuspendIcon />
              </span>
            )}
          </div>
        );
      case "action":
        return (
          <div className="flex items-center">
            <Button
              onClick={() => handleEditClick(item)}
              isIconOnly
              className="transparent-bg h-auto w-auto"
            >
              <EditIcon />
            </Button>
            {/* <Button */}
            {/*   onClick={handleViewReferralClick} */}
            {/*   isIconOnly */}
            {/*   className="transparent-bg h-auto w-auto" */}
            {/* > */}
            {/*   <ReferralIcon /> */}
            {/* </Button> */}
          </div>
        );
      case "no":
        return (
          <div className="">
            {data.findIndex(
              (row: any) => (row as any)?.id === (item as any)?.id,
            ) + 1}
          </div>
        );
      case "fullName":
        return <div className="font-bold">{item.fullName}</div>;
      case "tierId":
        return <div className="font-bold">{capitalize(item?.Tier?.name)}</div>;
      case "createdAt":
        return (
          <div className="w-max">
            <div>
              {format(item?.createdAt || new Date(), "dd/MM/yyyy HH:mm:ss")}
            </div>
          </div>
        );
      case "lastLogin":
        return (
          <div className="w-max">
            <div>
              {format(item?.lastLogin || new Date(), "dd/MM/yyyy HH:mm:ss")}
            </div>
          </div>
        );
      default:
        return (
          <div className="font-normal">
            {getKeyValue(item, columnKey as string) || "-"}
          </div>
        );
    }
  }, []);

  return (
    <div>
      {isEditingPlayer ? (
        <EditPlayerList
          itemData={editItemData!}
          onCancel={handleCancelEdit}
          items={[]}
        />
      ) : isResettingPw ? (
        <ResetPlayerPasswordView onCancel={handleResetPasswordCancel} />
      ) : (
        <div>
          <div className="font-ubuntu float-left text-center text-sm font-semibold text-white sm:text-lg">
            <p className="hidden sm:block">Player List</p>
          </div>
          <Datatable
            columns={columns}
            renderCell={renderCell}
            query={query}
            defaultRowsPerPage={"100"}
            customQueryFilter={{
              filter: selectedStatus,
            }}
            customFilters={[
              <div className="w-[170px] sm:w-2/5">
                <CustomDropdown
                  options={statuses}
                  onSelect={(e) => {
                    setSelectedStatus(e?.value || null);
                  }}
                  placeholder="ACTIVE"
                  value={selectedStatus ?? ""}
                />
              </div>,
            ]}
            searchFields={fields}
          />
        </div>
      )}
    </div>
  );
};

export default PlayerList;
